export const BASE_ROUTE = '/en-us/corporate';
export const ROUTE = {
  REGISTRATION: `${BASE_ROUTE}/registration`,
  ELIGIBILITY: `${BASE_ROUTE}/eligibility`,
  DASHBOARD: `${BASE_ROUTE}/dashboard`,
  PROFILE: `${BASE_ROUTE}/profile`,
  INVITE: `${BASE_ROUTE}/invite`,
  ERROR: `${BASE_ROUTE}/error`,
  LOGIN: '/en-us/account/login', // Todo: Update when login route is available
  FREEZE_CARD: `${BASE_ROUTE}/freeze-card`,
};

export const AMEX_CARD_IMAGE_SRC = 'https://www.aexp-static.com/cdaas/one/statics/@americanexpress/static-assets/2.32.3/package/dist/img/cards/generic/card-front.png';

export const TARGET_QUERY_PARAM = '?type=none&target=';
export const DESTINATION_PAGE_QUERY_PARAM = '?type=none&DestPage=';
export const ID_QUERY_PARAM = '?id=';

export const USER_STATUS = {
  INVITED: 4,
};

export const HEADERS = {
  CONTENT_TYPE: 'Content-Type',
  APPLICATION_JSON: 'application/json',
  TRANSACTION_ID: 'x-transaction-id',
  IDEMPOTENCY_KEY: 'x-idempotency-key',
  CONSUMER_ID: 'x-consumer-id',
  CHANNEL_TYPE: 'x-channel-type',
  INTERNET: 'INTERNET',
  APP_NAME: 'x-app-name',
  DVC_PORTAL: 'DVC_PORTAL',
  AT_WORK_CONSUMER_NAME: 'AT_WORK_CONSUMER_NAME',
};

export const EID_JOURNEY_KEYS = {
  DVC_RECIPIENT_SIGN_UP: 'DVC_RECIPIENT_SIGN_UP',
  DVC_VIEW_TOKEN_INFO: 'aexp.commercial:create:virtual_card',
};

export const ENDPOINTS = {
  GET_RECIPIENT_TOKENS: '/payments/digital/v1/virtual_payments/recipient/tokens',
  VALIDATE_INVITE: '/payments/digital/v1/virtual_payments/invited-recipient/validate?inviteCode=',
  RECIPIENT_ONBOARDING: 'payments/digital/v1/virtual_payments/recipient/onboarding',
  ONBOARDING_ELIGIBILITY: 'payments/digital/v1/virtual_payments/recipient/onboarding/eligibility',
  ONBOARDING_IDENTITY: 'payments/digital/v1/virtual_payments/recipient/onboarding/identity',
  ONBOARDING_FULFILLMENT: 'payments/digital/v1/virtual_payments/recipient/onboarding/fulfillment',
  ONBOARDING_STATUS: '/payments/digital/v1/virtual_payments/recipient/onboarding?inviteCode=',
  READ: 'ReadVirtualCard.v1',
  TOKEN_STATUS: '/payments/digital/v1/virtual_payments/tokenization/smart-token/status',
  RECIPIENT_PROFILES: '/payments/digital/v1/virtual_payments/recipient/profiles',
};

export const VIRTUAL_CARDS = {
  DEFAULT_PAGE: 1,
  DEFAULT_PAGE_SIZE: 6,
};

export const SORT_ORDER = {
  ASC: 'asc',
  DESC: 'desc',
};

export const UNIQUE_NAMES = {
  RECIPIENT_FIRST_NAME: 'firstName',
  RECIPIENT_MIDDLE_NAME: 'middleName',
  RECIPIENT_LAST_NAME: 'lastName',
  DATE_OF_BIRTH: 'dateOfBirth',
  MOBILE_NUMBER: 'mobileNumber',
  MOBILE_NUMBER_OPTIONS: 'mobileNumberOptions',
  EMAIL_ADDRESS: 'emailAddress',
  ADDRESS_LINE_1: 'addressLine1',
  ADDRESS_LINE_2: 'addressLine2',
  CITY: 'city',
  STATE: 'state',
  POSTAL_CODE: 'postalCode',
  COUNTRY: 'country',
};

export const SPACE = ' ';

export const TOKEN_STATUS = {
  ACTIVE: 'ACTIVE',
  SUSPENDED: 'SUSPENDED',
};

export const RECIPIENT_PROFILES_FILTER_KEYS = {
  RECIPIENT_ID: 'recipientId',
  COMPANY_ID: 'companyId',
};

export const FREEZE_CARD_PERSONAS = {
  DVC_RECIPIENT: 'DVC_RECIPIENT',
};

export const AMEX_REDIRECT_ALLOWED_HOSTS = ['americanexpress.com'];

export const AMEX_HOME_URL = 'https://www.americanexpress.com';

export const MODULE_IDS = {
  SMART_CHALLENGER: 'recipient-journey-wrapper:smart-challenger',
  PHONE_POSSESSION_CHECK: 'recipient-journey-wrapper:phone-possession-check',
  ONBOARDING_SUBMIT: 'recipient-journey-wrapper:onboarding-submit',
  UPDATE_SHALLOW_IDENTITY_SESSION: 'recipient-journey-wrapper:update-shallow-identity-session',
  OPEN_SIGN_UP: 'recipient-journey-wrapper:open-sign-up',
  FETCH_RECIPIENT_TOKENS: 'recipient-journey-wrapper:fetch-recipient-tokens',
  REQUIRE_VALID_SESSION: 'recipient-journey-wrapper:require-valid-session',
  VALIDATE_INVITE_CODE: 'recipient-journey-wrapper:validate-invite-code',
};

export const ERROR_LOG_MESSAGES = {
  SMART_CHALLENGER_CALLBACK_ERROR: 'SMART_CHALLENGER_CALLBACK_ERROR - SmartChallenger callback returned failure statusCode',
  SMART_CHALLENGER_INIT_ERROR: 'SMART_CHALLENGER_INIT_ERROR - SmartChallenger failed to initialize',
  PHONE_POSSESSION_CALLBACK_ERROR: 'PHONE_POSSESSION_CALLBACK_ERROR - Phone possession check callback returned failure statusCode',
  PHONE_POSSESSION_INIT_ERROR: 'PHONE_POSSESSION_INIT_ERROR - Phone possession check failed to initialize',
  ONBOARDING_GATEWAY_TIMEOUT: 'ONBOARDING_GATEWAY_TIMEOUT - Onboarding submission returned 504 gateway timeout, polling for status',
  UPDATE_SHALLOW_IDENTITY_SESSION_ERROR: 'UPDATE_SHALLOW_IDENTITY_SESSION_ERROR: UpdateIdentitySession.v1 failed with status',
  LOGIN_SIGNUP_CANCELLED: 'LOGIN_SIGNUP_CANCELLED - Signup widget returned statusCode',
  LOGIN_SIGNUP_ERROR: 'LOGIN_SIGNUP_ERROR - Signup widget returned failure statusCode',
  FETCH_RECIPIENT_TOKENS_ERROR: 'FETCH_RECIPIENT_TOKENS_ERROR - Recipient tokens fetch failed — HTTP',
  REQUIRE_VALID_SESSION_ERROR: 'REQUIRE_VALID_SESSION_ERROR - Session validation failed with status',
  VALIDATE_INVITE_CODE_INVALID_URL: 'VALIDATE_INVITE_CODE_INVALID_URL - Invalid or disallowed redemptionUrl',
};
